module.exports = __webpack_public_path__ + "static/img/7.8098af8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/sp/7.png
// module id = TS9l
// module chunks = 0